// The services registry — PORTED from the app's src/data/services.ts and
// src/chooseritual.tsx (2026-09-15). The app is the foundation; this file is
// its web mirror. Names, prices, deposits, exclusions and descriptions must
// never be edited here alone — change the app registry first, then re-port.
//
// 2026-10-08 (R-1008-01): The Ritual's model (modes, ages, focus, concerns,
// tiers, add-ons) is ported from the TOKEN SOURCE —
// holy-design/public/_hinge/tokens/ritual-bar.json → commerce — which is the
// point of truth for every name, price and note. See RITUAL … composite below.

window.RB = (function () {
  // GIDs from the app's SERVICE_GIDS — availability is one shared room pool
  // (the-ritual) for everything but the Friday consult.
  const GID = {
    'the-ritual':   'gid://shopify/Product/10689502642488',
    'skin-consult': 'gid://shopify/Product/10740945649976',
  };

  // key → the Shopify product handle the worker resolves. price/deposit in
  // dollars. `sellable:false` takes a request instead of a payment.
  const SERVICES = {
    // The Ritual is no longer booked as this product (R-1008-01): it is booked
    // as a TIER (the-ritual-relax-60 … the-ritual-work-90, see TIERS below).
    // This entry stays as the availability pool anchor + the "from" price the
    // menus show. `from` = the lowest tier (Relax · 60+).
    'the-ritual': {
      name: 'The Ritual', price: 160, from: true, deposit: 80, durationMin: 90, sellable: true,
      one: 'The facial, built around your skin.',
      depositLine: 'A deposit today, the rest at the Bar',
      // "What to expect" — the three notes every Ritual leaves with (the chooser's summary card).
      includes: [
        ['face',  'For your skin',   'Deep-cleansed, exfoliated, worked where it asks — nothing it doesn’t need.'],
        ['spark', 'For your face',   'The tension you carry — jaw, scalp, shoulders — given real time to let go.'],
        ['card',  'For your ritual at home', 'A note from your Guide after your visit — what’s worth repeating.'],
      ],
    },
    'skin-consult': {
      name: 'Skin consultation', price: 65, deposit: 32.5, durationMin: 30, sellable: true,
      one: 'A consultation that places your skin on a map — where it lands sets your steps and your products.',
      depositLine: '$32.50 today, the rest at the Bar',
      includes: [
        ['face',  'Read under light',  'Up close and in person, not from a photograph.'],
        ['card',  'Placed on a map',   'The point it lands on sets how many steps, and which kinds of product.'],
        ['clock', 'Yours to keep',     'In the app and your account, and sent to you after — short enough to actually do.'],
      ],
      note: 'Friday mornings. Yours to keep whether or not you book the Ritual.',
    },
    'microneedling-elevation': {
      name: 'Microneedling', price: 125, deposit: 62.5, durationMin: 90, sellable: true,
      one: 'Fine needles, sterile. The skin responds over weeks. Its own visit, with its own preparation and aftercare.',
      depositLine: '$62.50 today, the rest at the Bar',
      includes: [
        ['face',   'Candidacy first',   'A short check before anything touches your skin — some conditions and medications mean not today, and we say so.'],
        ['device', 'The work itself',   'A sterile cartridge, numbing cream first. Controlled micro-channels that switch on collagen production.'],
        ['plan',   'Aftercare that matters', 'Redness for a day or two is the process working. No actives, no sun — we send the plan home with you.'],
      ],
      note: 'Not during pregnancy, or within six months of isotretinoin. Your Guide confirms candidacy at the start.',
    },
    // Dermaplaning on its own (Preston 2026-10-14, $85 ruled the same night).
    'dermaplaning': {
      name: 'Dermaplaning', price: 85, deposit: 42.5, durationMin: 45, sellable: true,
      one: 'A sterile blade lifts peach fuzz and the dead surface layer. Smoother skin, and products sink in better.',
      depositLine: '$42.50 today, the rest at the Bar',
      includes: [
        ['face',   'Suitability first', 'Never over active breakouts or irritated skin. A short check, then we begin.'],
        ['device', 'The work itself',   'Light, even strokes across the face. No downtime.'],
        ['spark',  'The finish',        'Hydration pressed in. Makeup sits smoother for weeks.'],
      ],
    },
    'hydrodiamond': {
      name: 'Hydrodermabrasion', price: 125, deposit: 62.5, durationMin: 90, sellable: true,
      one: 'Diamond-tip resurfacing with vacuum extraction, serum running through it.',
      depositLine: '$62.50 today, the rest at the Bar',
      includes: [
        ['device', 'Resurface + extract', 'A dual diamond surface exfoliates while an adjustable vacuum clears the pore — both in one pass.'],
        ['drop',   'Serum-fed',           'Actives run through the tip while it works — the skin is fed in the same stroke that clears it.'],
        ['face',   'For congestion + texture', 'The workhorse for clogged, uneven skin.'],
      ],
    },
    'skin-scrubber': {
      name: 'Ultrasonic Exfoliation', price: 70, deposit: 35, durationMin: 90, sellable: true,
      one: 'A 28kHz spatula lifts buildup with no suction — the route for reactive or fragile skin.',
      depositLine: '$35 today, the rest at the Bar',
      includes: [
        ['device', 'Sound, not suction', '28,000 vibrations a second lift dead cells and sebum off the surface — nothing pulls at the skin.'],
        ['face',   'For reactive skin',  'Exfoliation when your skin argues with everything else.'],
        ['drop',   'Finished calm',      'Settled with hydration before you leave.'],
      ],
    },
    'dermedrop': {
      name: 'Needle-Free Mesotherapy', price: 95, deposit: 47.5, durationMin: 90, sellable: true,
      one: 'Electroporation — serum carried below the surface without breaking it.',
      depositLine: '$47.50 today, the rest at the Bar',
      includes: [
        ['device', 'Carried deeper',  'A gentle superficial current opens micro-channels; actives follow it below the surface.'],
        ['drop',   'For dehydration', 'Hydrators land where surface application cannot reach.'],
        ['face',   'No needles',      'The delivery without the puncture.'],
      ],
    },
    'dermeboost': {
      name: 'Oxygen Infusion', price: 65, deposit: 32.5, durationMin: 90, sellable: true,
      one: 'Serum delivered on a jet of oxygen — the gentlest way to get actives on.',
      depositLine: '$32.50 today, the rest at the Bar',
      includes: [
        ['drop',  'Pressure, not friction', 'Actives pressed in on air.'],
        ['face',  'For sensitive skin',     'When everything else is too much.'],
        ['spark', 'Immediate finish',       'Plump and calm, no downtime.'],
      ],
    },
    'vacuum-massage': {
      name: 'Lymphatic Drainage', price: 95, deposit: 47.5, durationMin: 90, sellable: true,
      one: 'Facial cupping — moves lymph and blood, so puffiness drops and the contour sharpens.',
      depositLine: '$47.50 today, the rest at the Bar',
      includes: [
        ['device', 'Cupping, moving', 'Adjustable vacuum through a glass tube, drawn along the lymph lines.'],
        ['face',   'For puffiness',   'Fluid moves; the face wakes up.'],
        ['spark',  'Contour',         'Cheekbones you had all along.'],
      ],
    },
    'cold-skin-toning': {
      name: 'Cold Therapy', price: 45, deposit: 22.5, durationMin: 90, sellable: true,
      one: 'Chilled steel across the face. Cold, not cryotherapy.',
      depositLine: '$22.50 today, the rest at the Bar',
      includes: [
        ['device', 'Chilled steel', 'Cold globes worked across the face.'],
        ['face',   'For redness',   'Vessels settle; pores read finer.'],
        ['spark',  'The close',     'Often the best last twenty minutes of a day.'],
      ],
    },
    'rf-skin-revitalization': {
      name: 'Radio Frequency Tightening', price: 110, deposit: 55, durationMin: 90, sellable: true,
      one: 'Warmth carried deep until the skin answers with collagen. Builds over a course.',
      depositLine: '$55 today, the rest at the Bar',
      includes: [
        ['device', 'Radio frequency', 'Deep, steady warmth under automated heat control — comfortable, never hot.'],
        ['face',   'For firmness',    'Collagen is a slow answer; this asks the question.'],
        ['plan',   'A course',        'Best as a series — your Guide maps the cadence.'],
      ],
    },
    'the-cut': {
      name: 'The Cut', price: 75, deposit: 37.5, durationMin: 60, sellable: true,
      one: 'Shaped to your head, washed at the basin, finished dry.',
      depositLine: '$37.50 today, the rest at the Bar',
      includes: [
        ['cut',   'Shape and finish',       'Checked dry before you leave, not just wet.'],
        ['wave',  'Washed in the chair',    'At the basin, then finished.'],
        ['clock', 'We do not color hair',   'Cut, treatment and length only.'],
      ],
    },
    'the-wash-and-mask': {
      name: 'The Wash and Blow Out', price: 65, deposit: 32.5, durationMin: 60, sellable: true,
      one: 'A wash at the basin, then a blow out — finished smooth.',
      depositLine: '$32.50 today, the rest at the Bar',
      includes: [
        ['wave',  'A full wash at the basin',        'Scalp worked, not just rinsed.'],
        ['drop',  'A mask through scalp and lengths','Left to sit while you do nothing.'],
        ['clock', 'Rinsed out, or left in',          'Your choice — leaving it in keeps it working.'],
      ],
    },
    'tape-in-extensions': {
      name: 'Tape-In Extensions', price: 700, deposit: 350, durationMin: 180, sellable: false,
      one: 'Wefts taped into your own hair, matched in the light and cut in.',
      depositLine: 'Nothing charged now — your Guide confirms by text',
      includes: [
        ['face',  'Matched before anything is taped', 'Colour and length matched against your own hair, under light.'],
        ['cut',   'Taped, then cut in',               'Sandwiched to your own strands. No heat, no glue, no rings.'],
        ['clock', 'Cut to sit like yours',            'Blended so the join is not the thing you notice.'],
      ],
      note: 'The hair comes with the service. Move-ups are booked separately, every six to eight weeks.',
    },
    'extension-move-up': {
      name: 'Extension Move-Up', price: 200, deposit: 100, durationMin: 120, sellable: true,
      one: 'Your tape-ins taken down, repositioned to the scalp, and re-taped.',
      depositLine: '$100 today, the rest at the Bar',
      includes: [
        ['drop',  'Taken down and washed',    'Your own hair cleansed and prepped before anything goes back on.'],
        ['cut',   'Repositioned to the scalp','Back where they started, now that your hair has grown.'],
        ['spark', 'Re-taped and finished',    'Fresh tape, then styled dry.'],
      ],
      note: 'Every six to eight weeks. Sooner if you wear it up most days.',
    },
  };

  // The facial focuses — OUTCOMES from the app's chooser (src/chooseritual.tsx),
  // mirrored verbatim. `focus` = the concern words a guest actually says (the
  // scannable list on each card); `desc` = the concern-led prose, shown only in
  // the expanded drawer. RF Tightening is NOT a focus — it's a standalone Work
  // treatment in the app (with Microneedling + Dermaplaning). Keep in sync.
  // `after` = the transformation line, the drawer's hero (how the skin will BE
  // afterward, beyond the plain title). Keep in sync with the app's
  // chooseritual.tsx OUTCOMES (Cold Therapy / Cool & Pore-Refine restored as a
  // focus per Preston, 2026-09-23).
  const OUTCOMES = [
    { key: 'hydrodiamond',     outcome: 'Bright & Even',      focus: 'Dullness · uneven tone', after: 'Brighter, more even skin — the dull, tired surface swept away.', desc: 'For dull, tired-looking skin. Water and light suction sweep away the dead surface layer that dulls your complexion — you leave brighter and smoother.', pill: 'Hydrodermabrasion' },
    { key: 'skin-scrubber',    outcome: 'Clear & Refine',     focus: 'Clogged pores · rough texture', after: 'Clearer pores and smoother skin — clean to the touch.', desc: 'For clogged pores and rough, bumpy texture. Gentle vibration loosens the buildup and blackheads scrubbing can’t reach — skin looks clearer, feels smoother.', pill: 'Ultrasonic Exfoliation' },
    { key: 'dermedrop',        outcome: 'Deep Hydration',     focus: 'Dryness · tightness',          after: 'Plump, soft, hydrated skin — the tightness gone.', desc: 'For dry, dehydrated skin that feels tight. Hydrating serum is pressed deeper than any cream can reach — no needles — so skin looks plumper and stays comfortable.', pill: 'Needle-free Mesotherapy' },
    { key: 'dermeboost',       outcome: 'Calm & Soothe',      focus: 'Redness · sensitivity',      after: 'Redness quieted — calm, even skin that stops reacting.', desc: 'For red, sensitive skin that reacts to everything. A stream of pure oxygen with a calming serum quiets redness and leaves skin settled, not flushed.', pill: 'Oxygen Infusion' },
    { key: 'vacuum-massage',   outcome: 'Sculpt & De-puff',   focus: 'Puffiness · a tired, heavy look',            after: 'De-puffed and lifted — your natural contour back.', desc: 'For a puffy, tired-looking face. Light, rhythmic massage moves the fluid that makes skin look swollen — your natural contour comes back.', pill: 'Lymphatic Drainage' },
    { key: 'cold-skin-toning', outcome: 'Cool & Pore-Refine', focus: 'Flushing · large-looking pores',       after: 'Flushing calmed, pores refined — skin cool and even.', desc: 'For redness and large-looking pores. A cold pass calms heat and inflammation and tightens the surface — pores look smaller, skin looks even.', pill: 'Cold Therapy' },
  ];

  // What cannot share a session — one mechanical injury or resurfacing
  // modality per visit (the app's EXCLUDES, keyed by handle).
  const EXCLUDES = {
    'hydrodiamond':           ['skin-scrubber'],
    'skin-scrubber':          ['hydrodiamond'],
  };

  // ── THE RITUAL, booked as The Signature or The Treatment (drawing, 2026-10-13) ──
  // From Tiana's mockup ("Facial Landing Page Redesign"), with Preston's rulings
  // B1–B8 of 2026-10-13. Names, lists and words are hers. Prices are unchanged.
  // The Shopify handles keep their old spelling (relax / work) so nothing breaks;
  // only what a guest reads has changed.
  //
  // Booked as: The Signature or The Treatment → 60 or 90 minutes → (Signature:
  // where you hold tension, a product duo) or (Treatment: what to work on, who
  // it is for, downtime) → a little extra → a time → your details.
  const RITUAL = {
    key: 'the-ritual', name: 'The Ritual', note: 'the facial, built around your skin',
    from: 160,
    blockMin: { 60: 90, 90: 120 },
  };
  const MODES = {
    signature: {
      key: 'signature', legacy: 'relax', name: 'The Signature', full: 'The Signature', short: 'Signature',
      benefit: 'A facial to release tension and keep skin healthy.', sub: 'Facial massage + custom skin care', subIcon: 'hands',
      addons: ['buccal', 'dermaplaning', 'foot-scrub'],
    },
    treatment: {
      key: 'treatment', legacy: 'work', name: 'The Treatment', full: 'The Treatment', short: 'Treatment',
      benefit: 'A facial for acne, pigmentation, texture, and skin renewal.', sub: 'Targeted treatments with modalities', subIcon: 'tools',
      addons: ['buccal', 'dermaplaning', 'foot-scrub'],
    },
  };
  // How often — her line and her words, shared by both rituals.
  const CADENCE = { line: 'Suggested every 4–6 weeks', why: 'Four to six weeks is a common facial-maintenance interval, not a requirement. Treatment series, chemical peels, and microneedling may need different schedules.' };
  const LEGACY_MODE = { relax: 'signature', work: 'treatment' };
  const AGES = [
    { key: 'adult', name: 'Adult' },
    { key: 'teen',  name: 'Teen (13–17)' },
  ];
  // The Signature · where you hold tension — any number, included. Six plain words (B6).
  const FOCUS = [
    { key: 'between-brows', name: 'Between brows' },
    { key: 'around-eyes',   name: 'Around eyes' },
    { key: 'smile-lines',   name: 'Smile lines' },
    { key: 'jaw',           name: 'Jaw' },
    { key: 'neck',          name: 'Neck' },
    { key: 'shoulders',     name: 'Shoulders' },
  ];
  const LEGACY_FOCUS = { 'the-11s': ['between-brows'], 'nasolabial': ['smile-lines'], 'crows-feet': ['around-eyes'], 'jaw-masseter': ['jaw'], 'neck-shoulders': ['neck', 'shoulders'] };
  // The Signature · a product duo to try — one, complimentary. Pairings pending Tiana (B17).
  const DUOS = [
    { key: 'none',     name: 'No preference' },
    // each duo is also listed as a facial of its own on /services, with a landing page (R-1014-07)
    { key: 'hydrate',  name: 'Hydration Duo',       facial: 'Hydration Duo Facial',       slug: 'hydration-duo-facial',       line: 'Double up on moisture.', detail: 'Two complementary hydrating products to replenish moisture and support the skin barrier. Try the textures and see how they layer together.' },
    { key: 'morning',  name: 'Morning Glow Duo',    facial: 'Morning Glow Duo Facial',    slug: 'morning-glow-duo-facial',    line: 'A little something for your morning routine.', detail: 'A vitamin C-focused pairing with complementary skin care. Try how it feels on your skin and learn where it could fit into your daily routine.' },
    { key: 'evening',  name: 'Evening Renewal Duo', facial: 'Evening Renewal Duo Facial', slug: 'evening-renewal-duo-facial', line: 'Actives for your nighttime routine.', detail: 'A pairing focused on texture and skin renewal. We’ll introduce the products and discuss whether they’re right for your routine.' },
    { key: 'featured', name: 'Currently Trying',    facial: 'Currently Trying Facial',    slug: 'currently-trying-facial',    line: 'Our newest favorite formula.', detail: 'A rotating product experience featuring interesting new formulas, potentially including exosome-, PDRN-, or peptide-focused skin care. Selected according to your skin’s needs.' },
  ];
  // The Treatment · what to work on — any number, or none ("Not sure yet").
  const CONCERNS = [
    { key: 'acne-breakouts', name: 'Acne' },
    { key: 'dark-spots',     name: 'Dark spots' },
    { key: 'texture',        name: 'Texture' },
    { key: 'maturing',       name: 'Maturing skin', adultOnly: true },
    { key: 'dryness',        name: 'Dryness' },
    { key: 'sensitivity',    name: 'Sensitivity' },
  ];
  // Where each service's landing page lives: /services/<slug> (mirrors services-render PAGES).
  const SLUGS = { buccal: 'buccal-massage', 'microneedling-elevation': 'microneedling', 'dermaplaning': 'dermaplaning', 'chemical-peel': 'chemical-peel', hydrodiamond: 'hydrodermabrasion', 'skin-scrubber': 'ultrasonic-exfoliation', dermedrop: 'needle-free-mesotherapy', dermeboost: 'oxygen-facial', 'vacuum-massage': 'lymphatic-drainage', 'cold-skin-toning': 'cold-therapy', 'rf-skin-revitalization': 'radio-frequency-tightening', 'skin-consult': 'skin-profile', 'the-cut': 'haircut', 'the-wash-and-mask': 'wash-and-blow-out', 'tape-in-extensions': 'tape-in-extensions', 'extension-move-up': 'extension-move-up' };
  const LEGACY_CONCERN = { breakouts: 'acne-breakouts', dryness: 'dryness', sensitivity: 'sensitivity', firmness: 'maturing', 'dark-spots': 'dark-spots' };
  const DOWNTIME = [
    { key: 'minimal', name: 'Prefer little to none' },
    { key: 'few',     name: 'Okay with a few days' },
    { key: 'unsure',  name: 'Not sure yet' },
  ];
  // "Read about treatments" — what the Guide may use; the guest never picks one.
  // The house product is named by what it is until its own name is settled (B18).
  const GUIDE = [
    { name: 'AHA exfoliation',             line: 'A lactic acid-based product for surface exfoliation and smoother-looking skin.' },
    { name: 'Professional chemical peels', line: 'Lactic, mandelic, and other appropriate peels selected for your skin and goals.' },
    { name: 'Microneedling',               line: 'For suitable texture concerns, with screening, aftercare, and individualized scheduling.', href: '/book?svc=microneedling-elevation', link: 'Its own visit, $125' },
    { name: 'Targeted technology',         line: 'Appropriate professional tools and modalities chosen after skin assessment.' },
  ];
  // The four tiers. `handle` = Shopify product = the cart's serviceKey.
  const TIERS = [
    { key: 'signature-60', handle: 'the-ritual-relax-60', mode: 'signature', length: '60', name: 'The Signature · 60 min', title: 'The Signature · 60 min', price: 160, deposit: 80,  durationMin: 90 },
    { key: 'signature-90', handle: 'the-ritual-relax-90', mode: 'signature', length: '90', name: 'The Signature · 90 min', title: 'The Signature · 90 min', price: 220, deposit: 110, durationMin: 120 },
    { key: 'treatment-60', handle: 'the-ritual-work-60',  mode: 'treatment', length: '60', name: 'The Treatment · 60 min', title: 'The Treatment · 60 min', price: 220, deposit: 110, durationMin: 90 },
    { key: 'treatment-90', handle: 'the-ritual-work-90',  mode: 'treatment', length: '90', name: 'The Treatment · 90 min', title: 'The Treatment · 90 min', price: 280, deposit: 140, durationMin: 120 },
  ];
  // A little extra — each its own Shopify product with a deposit variant = half.
  // Microneedling stays its own visit and is off this menu until it has an add-on price (B2).
  const ADDONS = [
    { key: 'buccal',       handle: 'addon-buccal',       name: 'Buccal massage', price: 75, info: 'For jaw tension and clenching. Includes massage inside the cheeks using gloves.', with: ['signature', 'treatment'] },
    { key: 'dermaplaning', handle: 'addon-dermaplaning', name: 'Dermaplaning',   price: 50, info: 'Removes peach fuzz and superficial dead skin for a smoother feel. Suitability is assessed before treatment.', with: ['signature', 'treatment'] },
    { key: 'foot-scrub',  handle: 'addon-foot-scrub',   name: 'Foot scrub',     price: 35, info: 'Warm foot soak, exfoliation, and moisturizer.', with: ['signature', 'treatment'] },
    // Chemical peel (Preston 2026-10-14, $60 ruled the same night): an add-on to either ritual.
    { key: 'chemical-peel', handle: 'chemical-peel', name: 'Chemical peel', price: 60, info: 'A light professional peel, chosen for your skin on the day. Plan a few quiet days after.', with: ['signature', 'treatment'] },
  ];
  // A treatment page opens The Treatment with its concern ticked, or The Signature (B8).
  const TREATMENTS = {
    'hydrodiamond':           { mode: 'treatment', concern: 'acne-breakouts' },
    'skin-scrubber':          { mode: 'treatment', concern: 'acne-breakouts' },
    'dermedrop':              { mode: 'treatment', concern: 'dryness' },
    'dermeboost':             { mode: 'treatment', concern: 'sensitivity' },
    'rf-skin-revitalization': { mode: 'treatment', concern: 'maturing' },
    'vacuum-massage':         { mode: 'signature' },
    'cold-skin-toning':       { mode: 'signature' },
  };
  const tierFor = (mode, length) => TIERS.find((t) => t.mode === mode && t.length === String(length)) || null;
  const modeFrom = (mode) => Math.min(...TIERS.filter((t) => t.mode === mode).map((t) => t.price));
  const addonsFor = (mode) => ADDONS.filter((a) => !a.pending && (!mode || a.with.includes(mode)));
  const half = (n) => Math.round(n * 50) / 100;

  // THE MONEY, ONE SOURCE: composite = tier + Σ extras · today = half of the
  // composite (what the cart charges) · at the Bar = the other half.
  //   sel = { mode, tier: '60'|'90', addons: [keys] }
  function composite(sel) {
    sel = sel || {};
    const mode = MODES[sel.mode] ? sel.mode : null;
    const tier = mode && sel.tier ? tierFor(mode, sel.tier) : null;
    const allowed = addonsFor(mode).map((a) => a.key);
    const addons = (sel.addons || []).filter((k) => allowed.includes(k)).map((k) => ADDONS.find((a) => a.key === k));
    const base = tier ? tier.price : (mode ? modeFrom(mode) : RITUAL.from);
    const total = base + addons.reduce((n, a) => n + a.price, 0);
    const from = !tier;
    const today = half(total);
    const head = tier ? `${MODES[mode].full} · ${tier.length} min` : (mode ? MODES[mode].full : RITUAL.name);
    const tr = sel.treatment && TREATMENTS[sel.treatment] && SERVICES[sel.treatment] ? SERVICES[sel.treatment] : null;
    const items = [{ name: tier ? tier.title : head, price: base, from }].concat(addons.map((a) => ({ name: a.name, price: a.price, add: true })));
    return {
      mode: mode ? MODES[mode] : null, tier, addons,
      total, from, deposit: today, today, atBar: Math.round((total - today) * 100) / 100,
      title: head, head, treatment: tr, items,
      durationMin: tier ? tier.durationMin : RITUAL.blockMin[60],
      complete: !!(mode && tier),
    };
  }

  // THE FEATURED OFFER (Preston 2026-10-25): buccal massage, booked as a ready
  // combination, The Signature at 60 minutes with the buccal add-on already
  // chosen. Its price is the composite (tier + add-on), never a number of its
  // own. Microneedling was featured before this; it stays a service of its own.
  // Mirrored in services-render.mjs FEATURED. The page is /services/buccal-massage.
  const FEATURED = { key: 'buccal', addon: 'buccal', mode: 'signature', length: '60', slug: 'buccal-massage' };
  FEATURED.href = `/book?start=${FEATURED.mode}&min=${FEATURED.length}&addons=${FEATURED.addon}`;

  // The services-page sections — the app door menu's arrangement.
  const SECTIONS = [
    { tag: 'Featured', featured: true, keys: [FEATURED.key] },
    { tag: 'Skin', keys: ['skin-consult', 'rf-skin-revitalization', 'hydrodiamond', 'skin-scrubber', 'dermedrop', 'dermeboost', 'vacuum-massage', 'cold-skin-toning'] },
    { tag: 'Hair', keys: ['the-cut', 'the-wash-and-mask', 'tape-in-extensions', 'extension-move-up'] },
  ];

  const money = (n) => '$' + (Number.isInteger(n) ? n : n.toFixed(2));

  // Small stroke icons, the app's ICONS vocabulary.
  const icon = (k, c) => {
    const P = {
      wand:   'M3 21l11-11M14 10l3-3M18 3v4M16 5h4M20 11h2M21 10v2',
      face:   'M12 3.5a8.5 8.5 0 1 0 0 17 8.5 8.5 0 0 0 0-17zM9 10h.01M15 10h.01M9 14.5c1 .9 2 1.3 3 1.3s2-.4 3-1.3',
      // the Bar's own glyphs (design system · foundations/iconography)
      hand:   'M8 12V6a1.5 1.5 0 0 1 3 0v5M11 11V4.5a1.5 1.5 0 0 1 3 0V11M14 11V6a1.5 1.5 0 0 1 3 0v8c0 3.5-2.5 6-6 6s-5.5-2-6.5-4.5L4 12a1.5 1.5 0 0 1 2.6-1.4L8 12.5',
      pin:    'M12 21s-6-6.2-6-11a6 6 0 0 1 12 0c0 4.8-6 11-6 11zM14 10a2 2 0 1 1-4 0 2 2 0 0 1 4 0z',
      arch:   'M6 21V8a6 6 0 0 1 12 0v13M6 21h12',
      device: 'M7 3.5h10v6a5 5 0 0 1-10 0zM12 14.5v6M9 20.5h6',
      drop:   'M12 3.5c3.5 4.5 6 7.5 6 10.5a6 6 0 1 1-12 0c0-3 2.5-6 6-10.5z',
      spark:  'M12 3v5M12 16v5M3 12h5M16 12h5M6 6l3 3M15 15l3 3M18 6l-3 3M9 15l-3 3',
      plan:   'M6 4.5h12v15H6zM9 9h6M9 12.5h6M9 16h4',
      card:   'M4 6.5h16v11H4zM4 10.5h16',
      clock:  'M12 3.5a8.5 8.5 0 1 0 0 17 8.5 8.5 0 0 0 0-17zM12 7.5V12l3 2',
      cut:    'M6 6l12 12M6 18L18 6M6.5 4.5a2 2 0 1 0 0 4 2 2 0 0 0 0-4zM6.5 15.5a2 2 0 1 0 0 4 2 2 0 0 0 0-4z',
      wave:   'M3 9c2.5-2.5 5-2.5 7.5 0S16 11.5 18.5 9M3 15c2.5-2.5 5-2.5 7.5 0s5.5 2.5 8 0',
      ritual: 'M12 3.5l7 5v10H5v-10z',
      info:   'M12 3.5a8.5 8.5 0 1 0 0 17 8.5 8.5 0 0 0 0-17zM12 11v5.5M12 7.6v.2',
    };
    return `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="${c}" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="miter" aria-hidden="true"><path d="${P[k] || P.face}"/></svg>`;
  };

  // The app's own instrument icons (PILL_ICONS, frontdoor.tsx) — ported paths,
  // one per treatment. The clinical lip everywhere uses THESE, never generics.
  const PILL_PATHS = {
    'rf-skin-revitalization': ['M13 2 3 14h9l-1 8 10-12h-9l1-8z'],
    'hydrodiamond':           ['M12 2.69l5.66 5.66a8 8 0 1 1-11.31 0z'],
    'skin-scrubber':          ['M22 12h-4l-3 9L9 3l-3 9H2'],
    'dermedrop':              ['M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z'],
    'dermeboost':             ['M9.59 4.59A2 2 0 1 1 11 8H2m10.59 11.41A2 2 0 1 0 14 16H2m15.73-8.27A2.5 2.5 0 1 1 19.5 12H2'],
    'vacuum-massage':         ['M20.24 12.24a6 6 0 0 0-8.49-8.49L5 10.5V19h8.5z', 'M16 8 2 22', 'M17.5 15H9'],
    'cold-skin-toning':       ['M14 14.76V3.5a2.5 2.5 0 0 0-5 0v11.26a4.5 4.5 0 1 0 5 0z'],
  };
  const pillIcon = (key, c, size) => {
    const paths = PILL_PATHS[key];
    if (!paths) return icon('device', c);
    const px = size || 18;
    return `<svg width="${px}" height="${px}" viewBox="0 0 24 24" fill="none" stroke="${c}" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${paths.map((d) => `<path d="${d}"/>`).join('')}</svg>`;
  };

  return { GID, SERVICES, OUTCOMES, EXCLUDES, SECTIONS, FEATURED, money, icon, pillIcon,
    // the new model (R-1008-01)
    RITUAL, MODES, CADENCE, LEGACY_MODE, AGES, FOCUS, LEGACY_FOCUS, DUOS, CONCERNS, LEGACY_CONCERN, DOWNTIME, GUIDE, TIERS, ADDONS, TREATMENTS, SLUGS, tierFor, modeFrom, addonsFor, composite };
})();
